export const SidebarSideTypes = {
  LEFT: "LEFT",
  RIGHT: "RIGHT"
};
